/*
 * Copyright The OpenTelemetry Authors
 * Copyright (c) 2025, Oracle and/or its affiliates.
 * SPDX-License-Identifier: Apache-2.0
 */

// Contains span names produced by instrumentation
// It lists the RPC names (suffix with _MSG like EXECUTE_MSG) and
// exported oracledb functions (like EXECUTE).
// These constants need to be in sync with what is generated by the
// 'oracledb' module.
export enum SpanNames {
  CONNECT = 'oracledb.getConnection',
  POOL_CONNECT = 'oracledb.Pool.getConnection',
  POOL_CREATE = 'oracledb.createPool',
  CONNECT_PROTOCOL_NEG = 'oracledb.ProtocolMessage',
  CONNECT_DATATYPE_NEG = 'oracledb.DataTypeMessage',
  CONNECT_AUTH_MSG = 'oracledb.AuthMessage',
  CONNECT_FAST_AUTH = 'oracledb.FastAuthMessage',
  EXECUTE_MSG = 'oracledb.ExecuteMessage',
  EXECUTE = 'oracledb.Connection.execute',
  EXECUTE_MANY = 'oracledb.Connection.executeMany',
  LOGOFF_MSG = 'oracledb.LogOffMessage',
  CONNECT_CLOSE = 'oracledb.Connection.close',
  CREATE_LOB = 'oracledb.Connection.createLob',
  LOB_MESSAGE = 'oracledb.LobOpMessage',
  LOB_GETDATA = 'oracledb.Lob.getData',
}
